import React from 'react';
import useAsyncDataCourier from '../../common/custom-hooks/useAsyncDataCourier';
import MessageCourier from '../../lib/MessageCourier';
import { Jugador } from '../../system/Jugador/Jugador';
import SystemClient from '../../system/SystemClient';
import ComboBoxSearch, { IComboBoxSearch } from '../Common/ComboBoxSearch';
import { IComboBoxOption } from '@fluentui/react';
import ComboBoxInput from '../../lib/FormValidator/Form/ComboBoxInput';
import CustomInputIfc from '../../lib/FormValidator/Form/CustomInputIfc';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import useForceUpdate from '../../common/custom-hooks/useForceUpdate';
interface IJugadorSelector {
  system: SystemClient;
  courier: MessageCourier;
  onSelect: (jugador: Jugador) => void;
  selected: string[];
  providedList?: Jugador[];
  noShowDocumentNumber?: boolean;
  clearOnSelect?: boolean;
  disabled?: boolean;
}

export const JugadorSelector = (props: IJugadorSelector) => {
  const jugadores = useAsyncDataCourier(
    () =>
      props.providedList
        ? Promise.resolve(props.providedList)
        : props.system.getJugadorSystem().getListForDropdown(),
    [props.providedList],
    props.courier
  );

  const getLabelFromJugador = (entity: Jugador) => {
    let extra = props.noShowDocumentNumber ? '' : `(Doc: ${entity.getDocumentoNumero()})`;
    const label = `${entity.getApellido()}, ${entity.getNombre()} ${extra}`;
    return label;
  };

  const jugadorOptions = React.useMemo(() => {
    let ret: IComboBoxOption[] = [];
    if (jugadores) {
      ret = jugadores.map((entity: Jugador) => {
        return { key: entity.getId()!, text: getLabelFromJugador(entity), data: entity };
      });
    }

    return ret;
  }, [jugadores]);

  const getFromKey = (key: string) => {
    if (jugadores) {
      const fed = jugadores.find((f) => f.getId() == key);
      if (fed) {
        return props.onSelect(fed);
      }
    }
  };

  return (
    <ComboBoxSearch
      onSelectOption={(opt) => getFromKey(String(opt.key))}
      selected={props.selected}
      options={jugadorOptions}
      cleanOnSelect={props.clearOnSelect}
      disabled={props.disabled}
      // comboProps={{ label: props.label, options: jugadorOptions }}
    ></ComboBoxSearch>
  );
};

interface IJugadorSelectorInput {
  system: SystemClient;
  courier: MessageCourier;
  input: CustomInputIfc;
  hideLabel?: boolean;
  filterByClubId?: string;
  onBlurCustomInput: (customInput: CustomInputIfc) => void;
  onChangeExtended?: (input: CustomInputIfc) => void;
  noShowDocumentNumber?: boolean;
}

export const JugadorSelectorInput = (props: IJugadorSelectorInput) => {
  const { t, i18n } = useTranslation();
  const [currentJugador, setCurrentJugador] = React.useState<Jugador | undefined>(undefined);
  const [jugadorOptions, setJugadorOptions] = React.useState<IComboBoxOption[]>([]);
  const jugadors = useAsyncDataCourier(
    () => props.system.getJugadorSystem().getListForDropdown(),
    [],
    props.courier
  );

  const mapJugadorOptions = (jugadors: Jugador[]) => {
    const opciones = jugadors.map((entity: Jugador) => {
      return { key: entity.getId()!, text: getLabelFromJugador(entity), data: entity };
    });
    setJugadorOptions(opciones);
  };

  const selectDefaultJugador = (id: string) => {
    setCurrentJugador(
      jugadors ? jugadors.find((entity: Jugador) => Number(entity.getId()) === Number(id)) : undefined
    );
  };

  const forceUpdate = useForceUpdate();

  const getLabelFromJugador = (entity: Jugador) => {
    let extra = props.noShowDocumentNumber ? '' : `(Doc: ${entity.getDocumentoNumero()})`;
    const label = `${entity.getApellido()}, ${entity.getNombre()} ${extra}`;
    // const label = String(entity.getApellido()) + ', ' + String(entity.getNombre()) + '';
    return label;
  };

  React.useEffect(() => {
    forceUpdate();
  }, [currentJugador]);

  React.useEffect(() => {
    selectDefaultJugador(props.input.getValue());
    mapJugadorOptions(jugadors ? jugadors : []);
  }, [jugadors, currentJugador]);

  const getStartingSelectionJugador = () => {
    let ret = '';
    if (jugadors) {
      const _entity = jugadors.find((e: Jugador) => Number(e.getId()) === Number(props.input.getValue()));
      if (_entity) ret = String(_entity.getId());
    }

    return ret;
  };

  React.useEffect(() => {
    if (props.filterByClubId && props.filterByClubId && jugadors) {
      const clubId = props.filterByClubId;
      if (jugadors) {
        mapJugadorOptions(
          jugadors.filter((entity: Jugador) => Number(entity.getClubid()) === Number(clubId))
        );
      }
      // console.log('leszId > ', leszId);
      // setJugadorOptions(undefined);

      console.log(props.filterByClubId);
    }
  }, [props.filterByClubId, jugadors]);

  return (
    <>
      {jugadors && (
        <ComboBoxInput
          input={props.input}
          label={props.hideLabel ? '' : t('Jugador')}
          onBlur={props.onBlurCustomInput}
          options={jugadorOptions ? jugadorOptions : []}
          selectedKey={props.input.getValue()}
          onChangeExtended={props.onChangeExtended}
        />
      )}
    </>
  );
};
